import { Component } from '@angular/core';
import { AuthPageLayoutComponent } from '../../../layout/auth-page-layout/auth-page-layout.component';
import { RegisterMerchantForm } from '../../../components/auth/register-merchant-form/register-merchant-form';

@Component({
  selector: 'app-register-merchant',
  imports: [
    AuthPageLayoutComponent,
    RegisterMerchantForm,
  ],
  templateUrl: './register-merchant.html'
})
export class RegisterMerchant {

}
